import { aiEvaluationReportLookupSchema, aiEvaluationSummarySchema, aiFeedbackLookupResponseSchema, aiFeedbackRequestSchema, aiFeedbackResponseSchema, aiOutcomeRequestSchema, type AiFeedbackRequest } from "@io-spoke/contracts/aiFeedback";
import { getApiClient } from "./apiClient";
export async function submitAiFeedback(responseId: string, input: AiFeedbackRequest) {
  const response = await getApiClient().put(`/ai-responses/${encodeURIComponent(responseId)}/feedback`, aiFeedbackRequestSchema.parse(input));
  return aiFeedbackResponseSchema.parse(response.data).feedback;
}
export async function getAiFeedback(responseId: string) {
  const response = await getApiClient().get(`/ai-responses/${encodeURIComponent(responseId)}/feedback`);
  return aiFeedbackLookupResponseSchema.parse(response.data).feedback;
}
export async function recordAiOutcome(responseId: string, outcome: "accepted" | "edited" | "rejected" | "succeeded" | "failed", note?: string) {
  await getApiClient().post(`/ai-responses/${encodeURIComponent(responseId)}/outcomes`, aiOutcomeRequestSchema.parse({ outcome, note }));
}
export async function getAiEvaluationSummary(workflow = "rescue_evidence") {
  const response = await getApiClient().get("/ai-responses/evaluation/summary", { params: { workflow } });
  return aiEvaluationSummarySchema.parse(response.data);
}
export async function getLatestAiEvaluationReport(workflow = "rescue_evidence") {
  const response = await getApiClient().get("/ai-responses/evaluation/reports/latest", { params: { workflow } });
  return aiEvaluationReportLookupSchema.parse(response.data).report;
}
